<nz-card class="flow-card" nzTitle="Plans & Add-ons">
  <p class="flow-card__subtitle">Select a base plan and any add-ons that fit the customer’s needs.</p>

  <form nz-form [formGroup]="planForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="dishPlan">Plans</nz-form-label>
      <nz-form-control>
        <nz-select
          id="dishPlan"
          formControlName="dishPlan"
          [nzCompareWith]="compareWithFn"
          nzPlaceHolder="Plan"
          [nzLoading]="loadingPlans"
        >
          <nz-option
            *ngFor="let p of dishPlans"
            [nzValue]="p.Product[0]"
            [nzLabel]="p.Product[0].ProductName"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item" *ngIf="dishPlanOffers">
      <nz-form-label [nzRequired]="true" nzFor="dishPlanOffer">Offers</nz-form-label>
      <nz-form-control>
        <nz-select
          id="dishPlanOffer"
          formControlName="dishPlanOffer"
          [nzCompareWith]="compareWithFn"
          nzPlaceHolder="Offer"
        >
          <nz-option
            *ngFor="let p of dishPlanOffers"
            [nzValue]="p"
            [nzLabel]="p.ProductName"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-collapse class="plan-collapse">
      <nz-collapse-panel nzHeader="Add-on Channels" [nzActive]="isAnyAddOnSelected()">
        <nz-collapse class="plan-collapse__nested" *ngFor="let channel of channels">
          <nz-collapse-panel [nzHeader]="channel.category" [nzActive]="isChannelActive(channel)">
            <div class="plan-option" *ngFor="let offer of channel.offer">
              <label
                nz-checkbox
                [nzChecked]="isSelected('addOnChannels', offer.ProductId)"
                (nzCheckedChange)="toggleProductId('addOnChannels', offer.ProductId)"
              >
                <span class="plan-option__name">{{ offer.ProductName }}</span>
                <span class="plan-option__price">{{ offer.Programming?.PricingMonthly | currency }}</span>
              </label>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </nz-collapse-panel>
    </nz-collapse>

    <nz-collapse class="plan-collapse">
      <nz-collapse-panel nzHeader="Promotional Offers" [nzActive]="isAnyOfferSelected()">
        <nz-collapse class="plan-collapse__nested" *ngFor="let promo of promos">
          <nz-collapse-panel [nzHeader]="promo.CategoryName" [nzActive]="isPromoActive(promo)">
            <div class="plan-option" *ngFor="let p of promo.Product">
              <label
                nz-checkbox
                [nzChecked]="isSelected('offers', p.ProductId)"
                (nzCheckedChange)="toggleProductId('offers', p.ProductId)"
              >
                <span class="plan-option__name">{{ p.ProductName }}</span>
                <span class="plan-option__price">{{ p.Programming?.PricingMonthly | currency }}</span>
              </label>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </nz-collapse-panel>
    </nz-collapse>

    <div class="flow-actions flow-actions--trailing">
      <button nz-button nzType="primary" nzBlock [disabled]="planForm.invalid" [nzLoading]="submittingLoader" (click)="submitPlan()">
        Next Step
      </button>
    </div>
  </form>
</nz-card>
